import { black, divider } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Card, CardContent, CardHeader, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

type TSectionCardProps = {
  title?: string | React.ReactNode;
  titleVariant?: "head20Bold" | "sub16Bold";
  titleColor?: string;
  headerAction?: ReactNode;
  maxWidth?: string | number;
};

export const SectionCard: FCC<TSectionCardProps> = ({
  title,
  titleVariant = "head20Bold",
  titleColor = black[30],
  headerAction,
  children,
  maxWidth = "900px",
}) => {
  return (
    <Card variant="outlined" sx={{ borderColor: divider.middle, borderRadius: "8px", maxWidth }}>
      {(title || headerAction) && (
        <CardHeader
          title={
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              {typeof title === "string" ? (
                <Typography variant={titleVariant} color={titleColor}>
                  {title}
                </Typography>
              ) : (
                title
              )}
              {headerAction}
            </Stack>
          }
          sx={{ pt: "24px", pb: 0, px: 3 }}
        />
      )}
      <CardContent sx={{ p: 3, "&:last-child": { pb: 3 } }}>{children}</CardContent>
    </Card>
  );
};
